exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes NLDO {\n    0% {\n        background-position: -468px 0;\n    }\n    100% {\n        background-position: 468px 0;\n    }\n}\n\n.ZBNP {\n    max-width: 400px;\n    border: 1px solid #e4e8eb;\n    border-radius: 6px;\n    background: white;\n    overflow: hidden;\n}\n\n._1AJN {\n    max-width: 550px;\n}\n\n.aaGV {\n    height: 110px;\n    margin-bottom: 15px;\n}\n\n._3mxr {\n    margin-bottom: 15px;\n    padding: 0 20px;\n}\n\n.rfRj {\n    height: 20px;\n    width: 150px;\n    margin-bottom: 5px;\n    background: #f6f7f8;\n}\n\n._3VNk {\n    height: 22px;\n    width: 360px;\n    margin-bottom: 15px;\n    background: #f6f7f8;\n}\n\n.BNeo {\n    animation-duration: 1.2s;\n    animation-fill-mode: forwards;\n    animation-iteration-count: infinite;\n    animation-name: NLDO;\n    animation-timing-function: linear;\n    background: #f6f7f8;\n    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);\n    background-size: 800px 104px;\n    position: relative;\n}\n", ""]);

// exports
exports.locals = {
	"container": "ZBNP",
	"wide": "_1AJN",
	"header": "aaGV",
	"body": "_3mxr",
	"label": "rfRj",
	"text": "_3VNk",
	"animatedBackground": "BNeo",
	"placeHolderShimmer": "NLDO"
};